import React, {FC} from 'react';
import styled from 'styled-components';

import {AttachmentsEditor, AttachmentsEditorProps} from '../../../common/attachments/attachmentsEditor';
import {attachmentSpacing} from '../activity/attachments/messageAttachment';

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  padding-top: ${attachmentSpacing}px;
`;

/*
 * Component.
 */

export const CommentComposerAttachments: FC<AttachmentsEditorProps> = (props) => (
  <StyledWrapperDiv>
    <AttachmentsEditor {...props} />
  </StyledWrapperDiv>
);
